import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('fileUpload');
const type = createActionType('fileUpload');

export const OPEN_DIALOG = type('OpenDialog');
export const CLOSE_DIALOG = type('CloseDialog');
export const CLOSE_DETAILS_DIALOG = type('CloseDetailsDialog');
export const CLOSE_OVERWRITE_DIALOG = type('CloseOverwriteDialog');
export const SET_FILE = type('SetFile');
export const INITIATE_DATA_UPLOAD = apiType('InitiateDataUpload');
export const COMPLETE_DATA_UPLOAD = apiType('CompleteDataUpload');
